// extracted by css-extract-rspack-plugin
export default {"wrapper":"_944026d9"};